import React, { useState, useEffect } from 'react';
import { Linkedin, Instagram, Mail, Phone } from 'lucide-react';
import { SectionHeader } from '../components/site/SectionHeader';
import { SEOHead } from '../components/site/SEOHead';
import api, { getFileUrl } from '../lib/api';

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get('/team?active_only=true').then(r => setMembers(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div data-testid="team-page">
      <SEOHead title="Ekibimiz" />
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">Ekibimiz</h1>
          <p className="text-gray-300 mt-2">Profesyonel kadromuzla tanışın</p>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {loading ? <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
          : members.length === 0 ? <div className="text-center py-20 text-muted-foreground">Henüz ekip üyesi eklenmemiş</div>
          : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {members.map(m => {
              const social = typeof m.social_links === 'string' ? JSON.parse(m.social_links || '{}') : (m.social_links || {});
              return (
                <div key={m.id} className="rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)] overflow-hidden text-center p-6">
                  <div className="w-28 h-28 rounded-full overflow-hidden bg-secondary mx-auto mb-4">
                    {m.image_path ? <img src={getFileUrl(m.image_path)} alt={m.name} loading="lazy" decoding="async" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-muted-foreground">{m.name?.[0]}</div>}
                  </div>
                  <h3 className="font-heading font-semibold text-base">{m.name}</h3>
                  {m.title && <p className="text-sm text-[hsl(var(--gold))] mt-1">{m.title}</p>}
                  {m.bio && <p className="text-xs text-muted-foreground mt-2 line-clamp-3">{m.bio}</p>}
                  <div className="flex justify-center gap-2 mt-4">
                    {m.email && <a href={`mailto:${m.email}`} className="p-2 rounded-lg hover:bg-secondary"><Mail className="w-4 h-4" /></a>}
                    {m.phone && <a href={`tel:${m.phone}`} className="p-2 rounded-lg hover:bg-secondary"><Phone className="w-4 h-4" /></a>}
                    {social.linkedin && <a href={social.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg hover:bg-secondary"><Linkedin className="w-4 h-4" /></a>}
                    {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg hover:bg-secondary"><Instagram className="w-4 h-4" /></a>}
                  </div>
                </div>
              );
            })}
          </div>}
        </div>
      </section>
    </div>
  );
}
